const ON_CHANGE_DEBOUNCE_TIMER = 300;
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
let subscribers = {};
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0,'',this.dataset.quantityVariantId,this.dataset.property);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      // this.onChange(event);
      // Only process change event for cart quantity inputs
    if (event.target.classList.contains('quantity__input')) {
      this.onChange(event);
    }
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) { 
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId,event.target.dataset.property);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId,property) {
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        //console.log("parsedState",parsedState);
            document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: parsedState,
            property:property
          }
        }));
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}



function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}


function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}


var addToCartBtn=document.querySelector('.cart__checkout-button');
var productBtn=document.querySelector('.add-to-cart');
document.addEventListener('drawerOpen', async function(evt) {
document.querySelector('.card-load ').classList.add('is-loading');
   var url = ''.concat('/cart.js?t=').concat(Date.now());
    var response = await fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      }).then( response => {
    return  response.json();
}) 
//alert("drawerOpen");
//gwpOffers(response);
//await upsellSection();

document.querySelector('.card-load ').classList.remove('is-loading');

});

document.addEventListener('cart:updated', async function(evt) {
  document.querySelector('.card-load ').classList.add('is-loading');
  console.log("cart:updatedddd",evt.detail);
  if(evt.detail.property=="_offerXProduct")
  {
     await processbuyXgetYOffers(evt.detail.cart)  
  }
  else { //alert("cart:updated");
    await gwpOffers(evt.detail.cart,false);  
  }

});


document.addEventListener('ajaxProduct:added', async function(evt) {
document.querySelector('.card-load ').classList.add('is-loading');
  console.log("ajaxProduct",evt.detail.product);
   var url = ''.concat('/cart.js?t=').concat(Date.now());
    var response = await fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      }).then( response => {
    return  response.json();
})
  if(evt.detail.product.properties && evt.detail.product.properties._offerXProduct ){ 
  processbuyXgetYOffers(response,false)  
  }
  else { //alert("ajaxProduct:added");
    gwpOffers(response,false)
  }
document.querySelector('.card-load ').classList.remove('is-loading');
});

// Fetch the section using the Shopify Section Rendering API
async function upsellSection() {
  const sectionUrl = window.Shopify.routes.root + 'cart?view=upsell-items';
  const response = await fetch(sectionUrl);
  const sectionData = await response.text();
  const html = document.createElement('div');
   html.innerHTML = sectionData;
   document.querySelector(".upsell__products_container").innerHTML=html.innerHTML;
   var CartDrawer =document.querySelector('#CartDrawer');
  eval(document.querySelector("#upsellFlickity").innerHTML)
   CartDrawer.querySelectorAll('.upsell-button').forEach(function(upsell){
   upsell.addEventListener('click', async function(evt) {
    addToCartBtn.classList.add('btn--loading');
        let formData = {
        'items': [{
        'id': evt.target.dataset.id,
        'quantity': 1
      }]
        };
      var result = await addProducts(formData);
      var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
      var response = await fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      }).then( response => {
    return  response.json();
    })
     await gwpOffers(response);
     await upsellSection();
     addToCartBtn.classList.remove('btn--loading');
})
})
}



async function gwpOffers(cart,openCart){ //alert('call')
       setTimeout(function() {
        initializeDatePicker();
    }, 100);
  addToCartBtn.classList.add('btn--loading');
  var cartData= cart;
  var cartTotal = cartData.total_price;
  var scriptElement=document.querySelector("#CartGwpOffer");
  var gwpOffers = scriptElement.textContent;
  gwpOffers = JSON.parse(gwpOffers);
  console.log("gwpOffers.offers",gwpOffers.offers)
  if(gwpOffers.offers != undefined)
  {
// Define the substrings and properties to consider for subtracting from cartTotal
//var subtractSubstrings = ['buyX', '_offerXProduct'];
var subtractSubstrings = ['_Offer', '_offerXProduct'];
// Loop through cartData.items and subtract prices of items with specific properties
cartData.items.forEach(item => {
  if(item.product_type == 'Combos'){
  cartTotal -= item.line_price;  
  }
  if (item.properties) {
    for (var prop in item.properties) {
      if (subtractSubstrings.some(substring => prop.includes(substring))) {
        cartTotal -= item.line_price;
        break;
      }
    }
  }
});
console.log(cartData,"Updated cartTotal:", cartTotal);
//In this code, we use the subtractSubstrings array to define the substrings and properties to consider for subtracting from cartTotal. The code then iterates through each item in cartData.items, and for each property in item.properties, it checks if the property key contains any of the specified substrings using the some method. If a match is found, it subtracts the item's price from cartTotal.

  cartTotal = cartTotal/100;
// Iterate through each offer in gwpOffers.offers
  document.querySelectorAll('.offerPriceContentSection').forEach(div => div.style.display = 'none');
  var gwpMessageDisplayPre=false
   // Arrays to store formData objects for add and remove operations

  const addFormDataArray=[];
  let finalFormData = {};
  const keyIds = [];
  const promises = gwpOffers.offers.map(async offer => {
  // Check if cartTotal is less than cart_total_above
 // console.log(cartTotal, "<", offer.cart_total_above)
  if (cartTotal < offer.cart_total_above) {
    // offer message display on the bottom
    if(!gwpMessageDisplayPre){
    var diff= "Rs."+Math.round(offer.cart_total_above-cartTotal);
    var offerMessage= (offer.message_if_cart_value_is_less_than_offer_value).replace('[value]',diff);
    var image=  `<img src="${document.querySelector('#offerPriceContent_'+offer.offerProperty).dataset.productImg}" />`;
    setTimeout(function(){ 
    document.querySelector('#offerPriceContent_'+offer.offerProperty).innerHTML='<span>'+image+offerMessage+'</span>';
    document.querySelector('#offerPriceContent_'+offer.offerProperty).style.display="block";
  },1000);
    gwpMessageDisplayPre=true;
    }
    // Check if the offerProperty value is found in CartData.items
    let offerPropertyFound = cartData.items.find(item => item.properties && item.properties._Offer==offer.offerProperty);
    //console.log("offerPropertyFound",offerPropertyFound)
    if (offerPropertyFound) {
      var keyId=  offerPropertyFound.key;
      keyIds.push(keyId);
      
       //var result= await removeProducts(formData); 
      //console.log(`Product '${offer.offerProperty}' removed from the cart.`);
    }
  }
  else {
  
    // Check if the offerProperty value is found in CartData.items
    let offerPropertyFound = cartData.items.some(item => item.properties && item.properties._Offer==offer.offerProperty);
    if (!offerPropertyFound) {
        let formData = {
        'id': offer.free_product_main,
        'quantity': 1,
        "properties" : {
        "_Offer": `${offer.offerProperty}`,
        "_Offer-limit":`${offer.cart_total_above}`
      }
        };
        
     //var result = await addProducts(formData); 
    addFormDataArray.push(formData);
    //console.log(`Product '${offer.offerProperty}' added to the cart.`);
    //console.log("offerPropertyFound",offerPropertyFound)
     setTimeout(function(){ 
    document.querySelector('#offerPriceContent_'+offer.offerProperty).innerHTML=offer.message_if_cart_value_is_greater_than_offer_value;
    document.querySelector('#offerPriceContent_'+offer.offerProperty).style.display="block";
     },1000);
    }
    else{
       setTimeout(function(){ 
    document.querySelector('#offerPriceContent_'+offer.offerProperty).innerHTML=offer.message_if_cart_value_is_greater_than_offer_value;
    document.querySelector('#offerPriceContent_'+offer.offerProperty).style.display="block";
       },1000);
    }
    
  }
   
});

await Promise.all(promises);
if(addFormDataArray.length >0){
    const formDataAdd = {
    'items': addFormDataArray
  };
   await addProducts(formDataAdd);  
  //document.dispatchEvent(new CustomEvent('cart:build'));
   await updateCart();
  //addToCartBtn.classList.remove('btn--loading');
  document.querySelector('.card-load ').classList.remove('is-loading');
  if(openCart) { document.querySelector(".js-drawer-open-cart").click();}
}  
else if(keyIds.length >0){
    const commonValue = 0;
// Use reduce to create the object
   const formDataObject = keyIds.reduce((obj, keyId) => {
  obj[keyId] = commonValue;
  return obj;
   }, {});
  await updateProducts(formDataObject); 
  await updateCart();
  //document.dispatchEvent(new CustomEvent('cart:build'));
 // addToCartBtn.classList.remove('btn--loading')
  //document.querySelector('.card-load ').classList.remove('is-loading');

  
  if(openCart) { document.querySelector(".js-drawer-open-cart").click();}
}
else {
    await updateCart();
  addToCartBtn.classList.remove('btn--loading')
  document.querySelector('.card-load ').classList.remove('is-loading');
  }  

  }
  else{
    updateCart();
  }
} 



async function processbuyXgetYOffers(cart, openCart) {
      setTimeout(function() {
        initializeDatePicker();
    }, 100);
  addToCartBtn.classList.add('btn--loading');
  var cartData = cart;
  var scriptElement = document.querySelector("#CartBuyXAndGetYOffer");
  var gwpOffers = JSON.parse(scriptElement.textContent);

  const promises = gwpOffers.offers.map(async offer => {
    if (offer.enable_offers) {
      const productXQuantities = {};
      let productYInCart = cartData.items.find(item => item.id === offer.product_y);

      for (let j = 1; j <= 25; j++) {
        const productXId = offer[`choose_product_x_${j}`];
        const productXInCart = cartData.items.find(item => item.id === productXId);
        if (productXInCart) {
          productXQuantities[productXId] = (productXQuantities[productXId] || 0) + productXInCart.quantity;
        }
      }

      // Calculate the total quantity of all productX items
      const totalProductXQuantity = Object.values(productXQuantities).reduce((total, quantity) => total + quantity, 0);
      
      const existingYQuantity = productYInCart ? productYInCart.quantity : 0;

      if (existingYQuantity < totalProductXQuantity) {
        // Add new Y products if necessary
        const formData = {
          'items': Array.from({ length: totalProductXQuantity - existingYQuantity }, () => ({
            'id': offer.product_y,
            'quantity': 1,
            'properties': {
              '_Offer': offer.offerProperty
            }
          }))
        };
        await addProducts(formData);
      } else if (existingYQuantity > totalProductXQuantity) {
        // Remove excess Y products if necessary
        const formData = {
          'id': productYInCart.key,
          'quantity': totalProductXQuantity
        };
        await removeProducts(formData);
      }

      if (existingYQuantity > 0 && totalProductXQuantity === 0) {
        // Remove Y product if it's not part of the offer anymore
        const formData = {
          'id': productYInCart.key,
          'quantity': 0
        }; 
        await removeProducts(formData);
      }
    }
  });

  await Promise.all(promises);
  await updateCart();
  // Cleanup and UI update operations here...
  if (openCart) {
    document.querySelector("#cart-icon-bubble").click();
  }
}


async function addProducts(formData){
await fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
})
.then(async response => {
  return await response.json();
})
.catch((error) => {
  console.error('Error:', error);
});
}
async function removeProducts(formData){
await fetch(window.Shopify.routes.root + 'cart/change.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
})
.then( async response => {
  return await response.json();
})
.catch((error) => {
  console.error('Error:', error);
});
}

async function updateProducts(updates){
  await fetch(window.Shopify.routes.root + 'cart/update.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({ updates })
})
.then(response => {
  return response.json();
})
.then(response => { console.log("updateProducts",response)
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
         const cartFooterDrawer = document.querySelector('.drawer__footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', response.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', response.item_count === 0);
        if (cartFooterDrawer) cartFooterDrawer.classList.toggle('is-empty', response.item_count === 0);
       
})
.catch((error) => {
  console.error('Error:', error);
});
}

async function updateCart(){
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => { 
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
           console.log("sourceElement.dataset.count",sourceElement.dataset.count)
            if(sourceElement.dataset.count){ document.querySelector('.header-cart__count').innerHTML=sourceElement.dataset.count;}
            if(sourceElement.dataset.count >0){ if(cartDrawerWrapper.querySelector('.drawer__inner-empty')){cartDrawerWrapper.querySelector('.drawer__inner-empty').remove();} document.querySelector('cart-drawer').classList.remove('is-empty');document.querySelector('.drawer__footer').classList.remove('is-empty'); }
            if(sourceElement.dataset.count ==0){  document.querySelector('cart-drawer').classList.add('is-empty'); document.querySelector('.drawer__footer').classList.add('is-empty');}
            if (html.querySelector('.drawer__inner-empty')) {
            // document.querySelector('.drawer__inner').insertBefore( 
            // html.querySelector('.drawer__inner-empty'), document.querySelector('.drawer__inner').firstChild); 
            if(document.querySelector('free-shipping-bar')){document.querySelector('free-shipping-bar').remove();}
            
            }
            
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
     if (!document.querySelector('cart-drawer').classList.contains('active')) {
  document.querySelector("#cart-icon-bubble").click();
}

        })
        .catch((e) => {
          console.error(e);
        });
}
    //CART UPSELL ITEM FUNCTION  
  /* $(document).on('click', '.upsell-button', function() { 
    var $self = $(this);
    var Id = $(this).closest('.ajaxcart__product').attr('id');   
    var Variant = $self.parents('.cart__item--variants').find('[name="variant"]').val();
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data : {
      id: parseInt(Variant),
      quantity: 1
      },
      dataType: 'json',
      success: function(data) {
      var selectors = {
      drawer: '#CartDrawer',
      container: '#CartContainer',
      template: '#CartTemplate',
      cartBubble: '.cart-link__bubble'
    }; 
      this.form = document.querySelector(selectors.form);
     // this.addToCart = form.querySelector(submitSelector);
      this.drawer = new theme.Drawers('CartDrawer', 'cart');
      document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data
            //addToCartBtn: this.addToCart
          }
        }));
    
       /* fetch('/cart?view=upsell-items')
        .then(function(response) { return response.text()})
        .then(function(html) {
         document.querySelector('.upsell__products_container').innerHTML = html;
        // document.querySelector('.partnerMessageBlock').innerHTML = upsellContent[1];
        })
        .catch(function(err) { console.log('Failed to fetch page: ', err); });
      */
    //theme.cartOffer.OfferHandler(); 
 /*       
      }
    })           
  }); */